'use client'

import { useEffect } from 'react'
import { useThree } from '@react-three/fiber'
import { THREE_FRAME_MS } from '../lib/graphics-budget'

type FpsInvalidatorProps = {
  active: boolean
}

export default function FpsInvalidator({ active }: FpsInvalidatorProps) {
  const invalidate = useThree((state) => state.invalidate)

  useEffect(() => {
    if (!active) return

    invalidate()
    const id = window.setInterval(() => invalidate(), THREE_FRAME_MS)
    return () => window.clearInterval(id)
  }, [active, invalidate])

  return null
}
